/**
 * This function returns a Google reCAPTCHA V3 token using the site key.
 * @returns A promise that resolves to a Google reCAPTCHA V3 token and rejects with the error in case of failure
 */

const getRecaptchaToken = (recaptchaSiteKey) => new Promise((res, rej) => {
    if (!window?.grecaptcha) { // eslint-disable-line no-undef
        rej(new Error('reCAPTCHA is not loaded. Make sure JavaScript is enabled in your browser.'));
    }
    window.grecaptcha.ready(() => {  // eslint-disable-line no-undef
        window.grecaptcha.execute(recaptchaSiteKey, { action: 'abtraShop' })  // eslint-disable-line no-undef
            .then((token) => res(token))
            .catch((e) => rej(e));
    });
});

export default getRecaptchaToken;